import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import logo from 'assets/images/logo.png';
import { Navigate, useLocation } from 'react-router-dom';

type State = {
  complete: boolean;
};

function RenewalConfirmation() {
  const { state } = useLocation();

  if (!state || !(state as State).complete) return <Navigate to="/" replace />;

  return (
    <Flex
      w="100%"
      h="100%"
      direction="column"
      align="center"
      p={10}
      borderTop="8px"
      borderColor="purple.500"
    >
      <Image src={logo} alt="LM logo" boxSize="120px" />
      <Box textAlign="center" mt={10}>
        <Heading as="h2">Thank you!</Heading>
        <Heading as="h4" size="md">
          Thank you for submitting your document renewal.
        </Heading>
        <Text mt={2}>A copy of the signed document will shortly be emailed to you!</Text>
      </Box>
    </Flex>
  );
}

export default RenewalConfirmation;
